var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row px-10"},_vm._l(([1,2,3,4,5,6,7,8]),function(discipline,index){return _c('div',{key:index,staticClass:"col-lg-3 col-md-3 mt-2 pt-2"},[_c('PuSkeleton',{attrs:{"height":"200px"}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }